import { combineReducers } from 'redux'
import { CommonState, CommonReducer } from './common/common.reducer'
import { AccountsReducer, AccountsState } from './accounts/accounts.reducer'

export interface ApiError {
  [key: string]: Response | Error | Record<string, unknown> | undefined
}

export interface RootState {
  commonStore: CommonState
  accountsStore: AccountsState
}

export const accountRootReducer = combineReducers<RootState>({
  commonStore: CommonReducer,
  accountsStore: AccountsReducer,
})
